import { Button } from "@devhop/ui";
import { HelpCircleIcon, PlusIcon } from "lucide-react";
import type { ProductCatalogConfig } from "./product-catalog-config";

type ProductsToolbarProps = {
  config: ProductCatalogConfig;
  canManage: boolean;
  onCreate: () => void;
  onStartTour?: () => void;
};

export function ProductsToolbar({
  config,
  canManage,
  onCreate,
  onStartTour,
}: ProductsToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="flex items-center font-bold text-2xl tracking-tight">
            {config.labels.listTitle}{" "}
            {onStartTour && (
              <Button
                variant="ghost"
                size="icon"
                onClick={onStartTour}
                className="ml-2 size-6"
                title="ເລີ່ມທົດລອງການນຳທາງ"
              >
                <HelpCircleIcon className="h-4 w-4" />
              </Button>
            )}
          </h2>
          <p className="text-muted-foreground">{config.labels.listDescription}</p>
        </div>
        <div className="flex items-center gap-2" data-tourid="products-toolbar">
          {canManage && (
            <Button onClick={onCreate}>
              <PlusIcon className="h-4 w-4" />
              {config.labels.createButton}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
